export function displayFileName(filename: string){
  if(filename.length > 18){
    return filename.substring(0, 18) + "...";
  }

  return filename
}
